export default __webpack_public_path__ + "static/media/amv.9eacbaa9.jpg";